<template>
  <div v-if="listOptions.length > 0">
    <p class="description">
      {{ label }}
    </p>
    <ul class="list">
      <li
        v-for="{ label, id } in listOptions"
        :key="id"
        class="item"
      >
        <input
          :id="id"
          v-model="model"
          type="radio"
          :value="id"
          :disabled="isDisabled"
        />
        <label
          :for="id"
          :class="isDisabled ? 'disabled' : ''"
        >
          {{ label }}
        </label>
      </li>
    </ul>
  </div>
  <p v-else>Nenhum título encontrado.</p>
</template>

<script>
import commonProperties from '../ui-types/common-properties';

export default {
  name: 'HeadingSelector',
  mixins: [commonProperties],
  props: {
    listOptions: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.description {
  font-weight: 500;
  font-size: 16px;
  line-height: 1.5;
  color: #757575;
  margin-bottom: 30px;
}

.list {
  display: flex;
  flex-wrap: wrap;
  margin: -10px;
}

.item {
  input {
    display: none;
    margin-right: 5px;

    &:checked + label {
      background-color: $primary-120;
      color: $gray-00;
    }
  }

  label {
    background-color: $gray-20;
    padding: 4px 16px;
    border-radius: 24px;
    margin: 5px;
    font-size: $size-normal;
    color: $gray-60;
    font-weight: $lb-medium;
    cursor: pointer;

    &.disabled {
      cursor: not-allowed;
    }
  }
}
</style>
